import { render, staticRenderFns } from "./QuotaBanner.vue?vue&type=template&id=67868fcb&scoped=true"
import script from "./QuotaBanner.vue?vue&type=script&lang=js"
export * from "./QuotaBanner.vue?vue&type=script&lang=js"
import style0 from "./QuotaBanner.vue?vue&type=style&index=0&id=67868fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67868fcb",
  null
  
)

export default component.exports